export function leadProjectsForUser(user, allProjects) {
  if (user?.role === 'superadmin' || user?.role === 'marketing') return allProjects;
  if (user?.role === 'sales_admin') return ['RMC'];
  return [];
}
